export const sxIconButton = {
  width: 40,
  height: 40,
  color: 'text.secondary',
};

export const sxBadge = {
  position: 'absolute',
  width: 10,
  height: 10,
  color: 'error.main',
  bottom: 10,
  right: 10,
};

export const sxPopoverContent = {
  p: 2,
  minWidth: 280,
};
